<template>
  <NavBar/>
    <div class="mid">
        <img src="../assets/particle.jpg" alt="" class="bg-pic">
        <div class="hero text-center">
            <br><br><br><br>
            <br><br><br><br>
            <h2>SONCRAFT</h2>
            <p>Free Projects and Games</p>
            <br><br><br><br>
            <a href="#featured">
                <img src="https://media.giphy.com/media/Wtg8Bmgul1Qxc0otod/source.gif" class="arrow_btn" alt="featured" width="100px" height="100px">
            </a>
        </div>
    </div>

    <section class="features min-vh-100 pt-5" id="featured" >
        <div class="heading container text-center pt-5">
            <h2 class="">Latest Projects</h2>
        </div>
        <!-- <span class="text-end">
            <h2 class=""><a href="/projects">see more></a></h2>
        </span> -->
        <div class="row mx-auto justify-content-center align-items-center text-center mt-3 pb-4">
            <div class="card project blender col-md-3 m-3 pt-3">
                <img src="../assets/projects/thumb-mech.png" class="card-img-top" alt="...">
                <div class="card-body px-0 pb-0">
                    <h4 class="card-title">Mech</h4>
                    <p>
                    </p>
                </div>
                <a href="https://download1653.mediafire.com/egzze0ilfvfg/r9hrc9ddroz8frg/Mech.zip" class="btn btn-success mb-3">Download</a>
            </div>
            <div class="card project java col-md-3 m-3 pt-3">
                <img src="../assets/projects/thumb-paint.png" class="card-img-top" alt="...">
                <div class="card-body px-0 pb-0">
                    <h4 class="card-title">JavaFX - Paint App</h4>
                    <p>Simple paint windows application with basic tools
                        like pencil, brush, eraser and shapes.
                    </p>
                </div>
                <a href="http://download1496.mediafire.com/0zjn4sdg78pg/nvljl636j0yhp7r/SimplePaintApp.zip" class="btn btn-success mb-3">Download</a>
            </div>
            <div class="card project java col-md-3 m-3 pt-3">
                <img src="../assets/projects/thumb-music-player.png" class="card-img-top" alt="...">
                <div class="card-body px-0 pb-0">
                    <h4 class="card-title">JavaFX - Music Player</h4>
                    <p>Play some musics with this simple mp3 player with JavaFX.</p>
                </div>
                <a href="http://download1638.mediafire.com/ctcdlcgkygfg/lbswdu3xvcehqqb/MusicPlayer.zip" class="btn btn-success mb-3">Download</a>
            </div>
        </div>
        <div class="heading container text-center">
            <h2 class="">Latest Games</h2>
        </div>
        <div class="row mx-auto justify-content-center align-items-center text-center mt-3 mb-4 pb-5">
            <div class="card project game col-md-3 m-3 pt-3">
                <img src="../assets/games/thumb-dagohoy.png" class="card-img-top" alt="...">
                <div class="card-body px-0 pb-0">
                    <h4 class="card-title">Dagohoy's Revolt</h4>
                    <p>
                    </p>
                </div>
                <a href="https://soncraft.itch.io/dagohoys-revolt" class="btn btn-success mb-3">Download</a>
            </div>
            <div class="card project game col-md-3 m-3 pt-3">
                <img src="../assets/games/thumb-leavingearth.png" class="card-img-top" alt="...">
                <div class="card-body px-0 pb-0">
                    <h4 class="card-title">Leaving Earth</h4>
                    <p>
                    </p>
                </div>
                <a href="https://soncraft.itch.io/leaving-earth" class="btn btn-success mb-3">Download</a>
            </div>
            <div class="card project game col-md-3 m-3 pt-3">
                <img src="../assets/games/thumb-itsybatsy.png" class="card-img-top" alt="...">
                <div class="card-body px-0 pb-0">
                    <h4 class="card-title">Itsy Batsy</h4>
                    <p>
                    </p>
                </div>
                <a href="https://soncraft.itch.io/itsy-batsy" class="btn btn-success mb-3">Download</a>
            </div>
        </div>
    </section>

  <Footer/>
</template>

<script>
// @ is an alias to /src
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'

export default {
  components: {
    NavBar,
    Footer
  },
  setup(){
    document.title = 'Soncraft - Home'
  }
}
</script>

<style>
.mid{
  background-color: #000;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  text-align: center;
}
.bg-pic{
  width: 100%;
  height: 100%;
  pointer-events: none;
  object-fit: cover;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.hero{
  position: relative;
}
.hero h2{
  color: #ff6600;
  font-size: 700%;
  font-weight: 800;
}
.hero p{
  color: #fff;
  font-size: 1.5rem;
  padding-left: 30%;
  padding-right: 30%;
}
.arrow_btn{
  cursor: pointer;
  width: 100px;
  height: 100px;
}
</style>
